<template>
  <div class="minePage">
    <!-- 个人信息栏目 -->
    <section class="mineIfnWrap">
      <van-row class="fvlr mineIfnBox">
        <van-col span="6">
          <div class="imgBox">
            <div class="headImgBox">
              <van-image v-if="headimgurl" fit="cover" :src="headimgurl">
                <template v-slot:error><img :src="headImgSrc"/></template>
              </van-image>
              <img v-else :src="headImgSrc" />
            </div>
            <img v-if="customerInfo.memberStatus === 1" class="vipImg" :src="vip" />
          </div>
        </van-col>
        <van-col span="18">
          <div class="nameBox">
            <p class="nameInf">
              <span class="userName">{{ personWXInfor.nickname }}</span>
              <span>{{ customerInfo.phone }}</span>
              <van-button class="updateInfo" square type="primary" size="mini" :text="hasCompletedInfo ? '修改信息' : '完善信息'" @click="toCompleteInfo" />
            </p>
            <div class="carInf">
              {{ customerInfo.licensePlate || '暂无车牌号' }}
              &nbsp;&nbsp;|&nbsp;&nbsp;
              {{ customerInfo.model || '暂无车辆数据' }}
            </div>
          </div>
        </van-col>
      </van-row>
      <van-row class="fvlr myDiscounts">
        <van-col span="11" @click="toMyPlanList">
          <span class="number">{{ customerInfo.myLoyaltyPlanCount }}</span>
          <p>我的卡券</p>
        </van-col>
        <van-col span="2">
          <div class=" dashedBox">
            <div class="dashedLine"></div>
          </div>
        </van-col>
        <van-col span="11" @click="toMyCouponList">
          <span class="number">{{ customerInfo.myCouponCount }}</span>
          <p>我的优惠券</p>
        </van-col>
      </van-row>
    </section>

    <!-- 订单信息栏目 -->
    <section class="orderIfnWrap">
      <div class="allOrderRow">
        <van-row class="allOrder">
          <van-col span="12" class="title">全部订单</van-col>
          <van-col span="12" @click="toOrderList({ id: 0 })">查看全部</van-col>
        </van-row>
      </div>
      <van-row>
        <van-col span="6" v-for="(item, index) in statusType" :key="index" @click="toOrderList(item)">
          <div class="gridCol">
            <van-badge v-if="item.num > 0" :content="item.num" color="#f49b55" max="10">
              <van-icon :name="item.icon" color="#3088c5" size="20" />
            </van-badge>
            <van-icon v-else :name="item.icon" color="#3088c5" size="20" />
            <p>{{ item.text }}</p>
          </div>
        </van-col>
      </van-row>
    </section>
    <!-- 跳转卡片 -->
    <section class="single-rows-container">
      <!-- <van-row class="singleRow">
        <van-cell class="enjoy" is-link value="" to="/exclusive">
          <template #title>
            <img class="enjoyImg" src="../../assets/images/enjoy.svg" />
            绑定用户专属服务通道
          </template>
        </van-cell>
      </van-row> -->
      <van-row class="singleRow">
        <van-cell title="车辆管理" icon="logistics" is-link value="" to="/carList?event=车辆管理" />
      </van-row>
      <van-row class="singleRow">
        <van-cell title="我的预约记录" icon="calendar-o" is-link value="" to="/oabList?event=预约列表" />
      </van-row>
      <!-- <van-row class="singleRow">
        <van-cell icon="bulb-o">
          <template #title>
            <div class="msgAgree">
              接收相关售后活动邀约及信息
              <van-icon name="question-o" @click="openMsgExplanation" />
            </div>
          </template>
          <van-switch :model-value="msgAgree" @update:model-value="changeMsgAgree" class="van-switch" />
        </van-cell>
      </van-row> -->
    </section>
    <van-popup v-model:show="showMsgExplanation" round>
      活动解释
      <van-button text="我已知悉" @click="closeMsgExplanation" />
    </van-popup>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import _ from 'lodash'
import { getEwCustomerInfo } from '@/api/mine'
import { getProfile, updateAgreePushMsg } from '@/api/profile'
import headImgSrc from '@/assets/images/headImg.png'
import vip from '@/assets/images/vipMark.png'
import { showToast } from '@/util/couponCollection'
// import { setSession, getSession } from '@/util'

export default {
  setup() {
    const router = useRouter()
    const store = useStore()
    const { profile } = store.state
    const state = reactive({
      headImgSrc,
      statusType: [
        { text: '待支付', num: 0, id: 1, icon: 'coupon-o' },
        { text: '待完成', num: 0, id: 2, icon: 'clock-o' },
        { text: '已完成', num: 0, id: 3, icon: 'flower-o' },
        { text: '退款/售后', num: 0, id: 4, icon: 'warning-o' }
      ],
      vip,
      customerInfo: {},
      mobelInfo: navigator.userAgent,
      showMsgExplanation: false,
      msgAgree: false
    })

    const hasCompletedInfo = computed(() => {
      return store.state.profile?.customerIdentity
    })

    // 头像图片
    const headimgurl = computed(() => {
      return store.state.personWXInfor.headimgurl?.replace('http', 'https')
    })
    // 头像图片
    const personWXInfor = computed(() => {
      return store.state.personWXInfor
    })
    // 跳转修改信息
    const toCompleteInfo = () => router.push({ path: '/completeInfo' })
    // 跳转订单列表
    const toOrderList = item => {
      router.push({ path: '/orderList', query: { status: item.id, event: '订单列表' } })
    }
    // 跳转我的致友计划列表
    let toMyPlanList = () => {
      router.push({ path: '/myLoyaltyPlanList', query: { event: '致友计划列表' } })
    }
    // 跳转我的优惠券列表
    let toMyCouponList = () => {
      router.push({ path: '/myCouponList', query: { event: '我的优惠券列表' } })
    }
    // 打开(关闭)活动解释弹窗
    const openMsgExplanation = () => (state.showMsgExplanation = true)
    const closeMsgExplanation = () => (state.showMsgExplanation = false)

    onMounted(async () => {
      const profileInfos = await getProfile()
      state.msgAgree = !!profileInfos.profile?.msgAgree
      // 获取当前用户信息
      try {
        let customerInfo = await getEwCustomerInfo({ customerId: 1 })
        state.customerInfo = customerInfo
        let keyArr = ['unpaidCount', 'undoneCount', 'unassessmentCount', 'refundCount']
        // 获取当前订单状态数量
        for (const i in keyArr) {
          if (Object.hasOwnProperty.call(keyArr, i)) {
            state.statusType[i].num = customerInfo[keyArr[i]]
          }
        }
        store.commit('SETPROFILE', {
          ...profile,
          username: customerInfo.username,
          phone: customerInfo.phone,
          customerIdentity: profileInfos.profile?.customerIdentity
        })
      } catch (error) {
        showToast(error.message, '用户信息请求失败')
      }
    })
    // 修改是否接受通知
    const changeMsgAgree = _.debounce(async val => {
      state.msgAgree = val
      await updateAgreePushMsg(val ? 1 : 0)
      const { profile: profileRes } = await getProfile()
      if (!profileRes) {
        state.msgAgree = !val
        return
      }
    }, 300)

    return {
      ...toRefs(state),
      toCompleteInfo,
      toOrderList,
      toMyPlanList,
      toMyCouponList,
      openMsgExplanation,
      closeMsgExplanation,
      headimgurl,
      personWXInfor,
      changeMsgAgree,
      hasCompletedInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.imgs {
  width: 50px;
  height: 50px;
}
.enjoy {
  background: url('../../assets/images/enjoybg.svg');
  background-size: cover;
}
.enjoyImg {
  margin-right: 10px;
}
:deep(.van-cell__title) {
  flex-grow: 2;
}
:deep(.van-cell__value) {
  align-items: center;
  display: flex;
  justify-content: right;
}
:deep(.van-image__error),
.van-image__loading {
  top: 19px;
}
.minePage {
  background-color: #f5f5f5;
  color: #666666;
  font-size: 12px;
}
// 个人信息
.mineIfnWrap {
  background: #f9f9f9 url('../../assets/images/mineBg.png') 0 0 no-repeat;
  background-size: 100% 100%;
  margin-bottom: 16px;
}
.mineIfnBox {
  padding: 25px 0 0 20px;
}
.imgBox {
  position: relative;
  width: 60px;
  height: 60px;
}
.headImgBox {
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  background-color: #fff;
  img {
    width: 60px;
    height: 60px;
  }
}
.vipImg {
  position: absolute;
  width: 22px;
  height: 22px;
  left: 38px;
  top: -12px;
}
.nameBox {
  text-align: left;
  .userName {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    margin-right: 14px;
  }
  .nameInf {
    display: flex;
    align-items: center;
  }
  .carInf {
    margin-top: 10px;
  }
  .updateInfo {
    margin-left: 14px;
  }
}

// 我的优惠信息
.myDiscounts {
  padding: 16px 0;
  // background-color: #777;
  .number {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  p {
    margin-top: 6px;
  }
}

// 分隔虚线
.dashedBox {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dashedLine {
  width: 1px;
  height: 50px;
  border-right: 1px dashed #ccc;
}
// 订单信息
.orderIfnWrap {
  margin-bottom: 16px;
  background-color: #fff;
}
.allOrderRow {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  text-align: right;
}
.allOrder {
  padding: 0 10px;
  border-bottom: 1px solid #ccc;
  .title {
    text-align: left;
    color: #333;
    font-size: 14px;
    font-weight: 600;
  }
}
.gridCol {
  padding: 20px 0;
  p {
    margin-top: 2px;
  }
}

// 跳转卡片
.single-rows-container .singleRow:last-of-type {
  margin-bottom: 2rem;
}

.singleRow {
  text-align: left;
  margin-bottom: 10px;
  :deep(.van-cell__left-icon) {
    vertical-align: middle;
    margin-right: 9px;
  }
}

.msgAgree {
  display: flex;
  align-items: center;
  :deep(.van-icon-question-o) {
    vertical-align: middle;
    height: 0.64rem;
    font-size: 0.42667rem;
    line-height: 0.64rem;
    color: #3088c5;
    margin-left: 0.12rem;
  }
}

.van-switch {
  font-size: 0.55rem;
}

:deep(.van-popup) {
  padding: 5%;
  width: 50%;
  height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: center;
}
</style>
